// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"heroImage-oj2ce"};